export const TILE_SIZE = { x: 680, y: 387 };
export const TILE_COUNT = { x: 10, y: 11 };
export const TILE_FULL_SIZE = { x: 6800, y: 4255 };
export const RADAR_FULL_SIZE = { width: 2550, height: 1600 };
export const RADAR_FINAL_SIZE = { width: 640, height: 367 };

// YEETLAB: 640x367 is the landscape band. Portrait used to take that same crop and
// scale it up, which is a zoom, not more map. The final height is now taken from the
// stage the app is actually drawn into (--yc-stage-height, pushed in by the parent
// shell), and the source crop grows with it at a fixed number of source rows per
// final pixel, so the radar EXTENDS to fill the screen at the original map scale.
export const RADAR_SOURCE_SIZE = { width: 240, height: 163 };

// taller than any phone stage; past this the doppler source runs out of rows
export const RADAR_MAX_HEIGHT = 1400;

export const getRadarFinalSize = () => {
	const stage = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--yc-stage-height'), 10);
	if (!stage) return { ...RADAR_FINAL_SIZE };
	return {
		width: RADAR_FINAL_SIZE.width,
		height: Math.min(RADAR_MAX_HEIGHT, Math.max(RADAR_FINAL_SIZE.height, Math.ceil(stage))),
	};
};

// map tiles are 145.095 px per degree of latitude, the doppler half-space is 61.4481
export const MAP_PER_DOPPLER_ROW = 145.095 / 61.4481;

// source rows needed to keep the map scale constant at the requested final height
export const getRadarSourceSize = (finalSize) => ({
	width: RADAR_SOURCE_SIZE.width,
	height: Math.round(RADAR_SOURCE_SIZE.height * (finalSize.height / RADAR_FINAL_SIZE.height)),
});
